module.exports = __webpack_public_path__ + "img/star2.188ac8d3.png";